module.exports = __webpack_public_path__ + "img/welcome_card.6c37cd98.svg";